import { h } from 'preact';
import MenuItem from './v-menu-item';

const MainMenu = ({ menu }) => {
  if (!menu) return null;

  return (
    <ul className="flex flex-col gap-y-5 laptop:flex-row laptop:gap-x-10">
      {menu.map((link) => (
        <MenuItem
          link={link}
          key={`v-${link.title}-${link.url}`}
        />
      ))}
    </ul>
  );
};

export default MainMenu;
